import Vue from 'vue'
// 登入
import { baseURL } from '../config'
var baseURL2 = 'https://apiwww.rakumart.com'
// 获取用户信息
export const getUser = data => Vue.prototype.getAxios(baseURL + '/index.php?mod=inc&act=ordersys&str=getUserInfo&token=' + localStorage.getItem('token'), data)
export const login = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 注册
export const formRegister = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 发送短信
export const sendSMS = data => Vue.prototype.postAxios("https://apiwww.rakumart.com/client/getRegisterVerificationCode", data)

// 字段验证
export const checkRegisterField = data => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=li_ajax&str=checkRegisterField", data)

// 获取图形验证码
export const clientCodeImg = data => Vue.prototype.getAxios(baseURL2 + "/client/codeImg", data)

// 校验注册验证码
export const checkRegisterCode = data => Vue.prototype.postAxios(baseURL2 + "/client/checkRegisterCode", data)

// 1688会员注册
export const alibabaUserRegister = data => Vue.prototype.postAxios("https://www.rakumart-2c.com:8080/api/client/alibabaUserRegister", data)
// 1688会员注册查询
export const alibabaUserRegisterList = data => Vue.prototype.postAxios("https://www.rakumart-2c.com:8080/api/client/alibabaUserRegisterList", data)

